// extracted by mini-css-extract-plugin
module.exports = {"waldorfCompany":"style_waldorfCompany__T9fgv","companyTabElement":"style_companyTabElement__DXQTd","activeLink":"style_activeLink__ZEKIS"};